import React, { FC } from 'react'

import styled from 'styled-components'

import { numberFormatCommas } from 'src/Constants/functions'
import { PrimarySkeleton } from 'src/Components/Skeletons/PrimarySkeleton'
import CashIcon from 'src/Assets/Svg/artist-balance-icons/Balance.svg?react'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'

const Container = styled.div`
  display: flex;
  min-width: 288px;
  padding: 24px;
  align-items: center;
  align-content: center;
  gap: 40px;
  align-self: stretch;
  flex-wrap: wrap;

  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  background: ${({ theme }) => theme.color.white};
  border-radius: 16px;
  @media screen and (min-width: ${MAX_MOBILE_WIDTH}) {
    box-shadow: ${({ theme }) => theme.shadow.card};
  }
`
const StatsBlock = styled.div`
  display: flex;
  min-width: 100px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
  @media screen and (min-width: ${MAX_MOBILE_WIDTH}) {
    min-width: 80px;
  }
`
const Title = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`
const Value = styled(Title)`
  font-size: 18px;
  font-weight: 600;
`

const StyledSkeleton = styled(PrimarySkeleton)`
  border-radius: 16px;
  height: 120px;
`

const Icon = styled(CashIcon)`
  display: none;
  @media screen and (min-width: ${MAX_MOBILE_WIDTH}) {
    display: block;
  }
`
type StatsBlockProps = {
  balance?: number
  used?: number
  paid?: number
  isLoading?: boolean
}

export const BalanceStats: FC<StatsBlockProps> = ({
  balance,
  used,
  paid,
  isLoading,
}) => {
  if (isLoading) {
    return <StyledSkeleton role='skeleton' />
  }
  return (
    <Container>
      <Icon width={'32px'} height={'32px'} />
      <StatsBlock>
        <Title>Current balance</Title>
        <Value>{`$${numberFormatCommas(balance)}`}</Value>
      </StatsBlock>
      <StatsBlock>
        <Title>Total paid</Title>
        <Value>{`$${numberFormatCommas(paid)}`}</Value>
      </StatsBlock>
      <StatsBlock>
        <Title>Total used</Title>
        <Value>{`$${numberFormatCommas(used)}`}</Value>
      </StatsBlock>
    </Container>
  )
}
